<template>
  <div class="wrap home">
    <br>
    <companyReg nextRoute="/recap" v-if="fieldType === '0'" />
    <industry nextRoute="/recap" v-else-if="fieldType === '1'" />
    <turnover nextRoute="/recap" v-else-if="fieldType === '2'" />
    <homeowner nextRoute="/recap" v-else-if="fieldType === '3'" />
    <years nextRoute="/recap" v-else-if="fieldType === '4'" />
    <customers nextRoute="/recap" v-else-if="fieldType === '5'" />
    <credit nextRoute="/recap" v-else />
  </div>
</template>
<script>
import companyReg from "@/views/questions/companyReg.vue";
import industry from "@/views/questions/industry.vue";
import turnover from "@/views/questions/turnover.vue";
import homeowner from "@/views/questions/homeowner.vue";
import years from "@/views/questions/yearsTrading.vue";
import customers from "@/views/questions/expectedCustomers.vue";
import credit from "@/views/questions/creditControl.vue";
export default {
  components: {
    companyReg,
    industry,
    turnover,
    homeowner,
    years,
    customers,
    credit
  },
  props: {
    fieldType: String
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
}
</style>